import { getMaterialsAnalytics } from '../../api/analytics';
import { deletePanInfo, getDumpPanInfo, getDumpPanTotal, getExelExportDumpPan } from '../../api/dumpPanInfo';
import { downloadFile } from '../../utils';
import { handleActionAbortController } from '../../utils/handleActionAbortController';

export const CHANGE_DUMP_PAN_VALUE = 'CHANGE_DUMP_PAN_VALUE';
export const CHANGE_DUMP_PAN_SEVERAL_VALUES = 'CHANGE_DUMP_PAN_SEVERAL_VALUES';
export const RESET_DUMP_PAN_STORE = 'RESET_DUMP_PAN_STORE';

export const GET_DUMP_PAN_EVENTS = 'GET_DUMP_PAN_EVENTS';
export const GET_DUMP_PAN_EVENTS_SUCCESS = 'GET_DUMP_PAN_EVENTS_SUCCESS';
export const GET_DUMP_PAN_EVENTS_ERROR = 'GET_DUMP_PAN_EVENTS_ERROR';

export const DELETE_DUMP_PAN = 'DELETE_DUMP_PAN';
export const DELETE_DUMP_PAN_SUCCESS = 'DELETE_DUMP_PAN_SUCCESS';
export const DELETE_DUMP_PAN_ERROR = 'DELETE_DUMP_PAN_ERROR';

export const LOAD_DUMP_PAN_FILE = 'LOAD_DUMP_PAN_FILE';
export const LOAD_DUMP_PAN_SUCCESS = 'LOAD_DUMP_PAN_SUCCESS';
export const LOAD_DUMP_PAN_ERROR = 'LOAD_DUMP_PAN_ERROR';

export const GET_DUMP_PAN_ANALYTIC = 'GET_DUMP_PAN_ANALYTIC';
export const GET_DUMP_PAN_ANALYTIC_SUCCESS = 'GET_DUMP_PAN_ANALYTIC_SUCCESS';
export const GET_DUMP_PAN_ANALYTIC_ERROR = 'GET_DUMP_PAN_ANALYTIC_ERROR';

export const getDumpPanInfAction = (function () {
  let prevController;

  return (params, actions = null) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_DUMP_PAN_EVENTS, payload: params.cursorDirection === 'FIRST' });
      try {
        const response = await getDumpPanInfo(params, abortController.signal);
        const { success, results } = response;
        if (success && results && !abortController.signal.aborted) {
          dispatch({ type: GET_DUMP_PAN_EVENTS_SUCCESS, payload: results, params });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error);
          actions?.onError(error.message);
          dispatch({ type: GET_DUMP_PAN_EVENTS_ERROR, params });
        }
      }
    };
  };
})();

export const getDumpPanAnalyticAction = (function () {
  let prevController;

  return (params) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_DUMP_PAN_ANALYTIC, payload: params.cursorDirection === 'FIRST' });
      try {
        const [response, totalResponse] = await Promise.all([
          getMaterialsAnalytics(params, abortController.signal),
          getDumpPanTotal(
            {
              startTime: params.startEventTime,
              endTime: params.endEventTime,
              restaurantUuid: params.restaurantsUuid,
              materials: params.materials,
            },
            abortController.signal
          ),
        ]);

        const { success, results } = response;
        const { success: totalSuccess, results: total } = totalResponse;
        if (success && totalSuccess && !abortController.signal.aborted) {
          dispatch({ type: GET_DUMP_PAN_ANALYTIC_SUCCESS, payload: { results, total }, params });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error);
          dispatch({ type: GET_DUMP_PAN_ANALYTIC_ERROR });
        }
      }
    };
  };
})();

export const deleteDumpPanAction = (uuid, actions = null) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_DUMP_PAN });
    try {
      const response = await deletePanInfo(uuid);
      const { success } = response;
      if (success) {
        actions?.onSuccess();
        dispatch({ type: DELETE_DUMP_PAN_SUCCESS });
      }
    } catch (error) {
      console.log(error);
      actions?.onError(error.message);
      dispatch({ type: DELETE_DUMP_PAN_ERROR });
    }
  };
};

export const downloadEventsFile = (params, actions) => {
  return async (dispatch) => {
    dispatch({ type: LOAD_DUMP_PAN_FILE });
    try {
      const response = await getExelExportDumpPan(params);
      const { success, results } = response;
      if (success) {
        response.code !== 202 && downloadFile(results, 'application/zip');
        dispatch({ type: LOAD_DUMP_PAN_SUCCESS });
        if (actions.onSuccess) {
          actions.onSuccess(response);
        }
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: LOAD_DUMP_PAN_ERROR });
      if (actions.onError) {
        actions.onError(error.message);
      }
    }
  };
};

export const changeValue = (key, value) => ({
  type: CHANGE_DUMP_PAN_VALUE,
  payload: {
    key,
    value,
  },
});

export const changeSeveralValues = (value) => ({
  type: CHANGE_DUMP_PAN_SEVERAL_VALUES,
  payload: value,
});

export const resetStore = () => ({
  type: RESET_DUMP_PAN_STORE,
});
